import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import $ from 'jquery'; 
import 'datatables.net'; 
import 'datatables.net-dt/css/jquery.dataTables.min.css'; 

const Flipbook = () => {
    const [chapters, setChapters] = useState([]);
    const [newChapterName, setNewChapterName] = useState('');
    const [showInput, setShowInput] = useState(false);
    const navigate = useNavigate();

    // Fetch GuideChapter collection from Firestore
    useEffect(() => {
        const fetchChapters = async () => {
            try {
                const chaptersCollection = collection(db, 'GuideChapter');
                const chaptersSnapshot = await getDocs(chaptersCollection);
                const chaptersList = chaptersSnapshot.docs.map((doc) => ({
                    id: doc.id, 
                    guideChapterName: doc.data().guideChapterName || 'Unnamed Chapter',
                }));
                console.log("Fetched Chapters:", chaptersList);
                setChapters(chaptersList);
            } catch (error) {
                console.error('Error fetching chapters:', error);
            }
        };

        fetchChapters();
    }, []);

    // Handle Add Chapter click (show input box)
    const handleShowInput = () => {
        setShowInput(true);
    };

    // Handle navigating to the edit page with a new chapter name
    const handleAddChapter = () => {
        if (newChapterName.trim()) {
            navigate(`/edit-chapter/${newChapterName}`);
        } else {
            alert("Please enter a chapter name.");
        }
    };

    // Navigate to edit page
    const handleEdit = (chapterId) => {
        navigate(`/edit-chapter/${chapterId}`);
    };

    const handleDashboard = () => {
        navigate('/dashboard');
    };

    // Delete a chapter from Firestore
    const handleDelete = async (chapterId) => {
        if (window.confirm('Are you sure you want to delete this chapter?')) {
            try {
                await deleteDoc(doc(db, 'GuideChapter', chapterId)); 
                setChapters((prevChapters) =>
                    prevChapters.filter((chapter) => chapter.id !== chapterId)
                );
                alert('Chapter deleted successfully.');
            } catch (error) {
                console.error('Error deleting chapter:', error);
                alert('Failed to delete the chapter. Please try again.');
            }
        }
    };

    // Initialize DataTable
    useEffect(() => {
        const initializeDataTable = () => {
            if ($.fn.DataTable.isDataTable('#chapters-table')) {
                $('#chapters-table').DataTable().destroy();
            }

            $('#chapters-table').DataTable({
                data: chapters.map((chapter) => ({
                    id: chapter.id || 'N/A', 
                    title: chapter.guideChapterName || 'Unnamed Chapter'
                })),
                columns: [
                    { title: 'Chapter ID', data: 'id' },
                    { title: 'Title', data: 'title' }, 
                    {
                        title: 'Actions',
                        data: null,
                        render: (data, type, row) => `
                            <button class="edit-button" data-id="${row.id}">Edit</button>
                            <button class="delete-button" data-id="${row.id}">Delete</button>
                        `,
                    },
                ],
                destroy: true,
                paging: true,
                searching: true,
                info: true,
                autoWidth: false,
            });

            console.log('Chapters Loaded:', chapters); 

            // Attach event handlers for edit and delete buttons
            $('#chapters-table tbody').off('click', '.edit-button');
            $('#chapters-table tbody').on('click', '.edit-button', function () {
                const chapterId = $(this).data('id');
                handleEdit(chapterId);
            });

            $('#chapters-table tbody').off('click', '.delete-button');
            $('#chapters-table tbody').on('click', '.delete-button', function () {
                const chapterId = $(this).data('id');
                handleDelete(chapterId);
            });
        };

        if (chapters.length > 0) {
            initializeDataTable();
        }
    }, [chapters]);

    // Handle logout
    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                navigate('/');
            })
            .catch((error) => {
                console.error('Logout Error:', error);
                alert('Failed to logout. Please try again.');
            });
    };

    return (
        <div className="dashboard">
            <div className="dashboard-header">
                <h1>HonestAI Chapter Dashboard</h1>
                <button onClick={handleDashboard}>Dashboard</button>
                {!showInput ? (
                    <button className="add-chapter-button" onClick={handleShowInput}>
                        ➕ Add Chapter
                    </button>
                ) : (
                    <div className="add-chapter-input">
                        <input
                            type="text"
                            placeholder="Enter chapter name..."
                            value={newChapterName}
                            onChange={(e) => setNewChapterName(e.target.value)}
                        />
                        <button onClick={handleAddChapter}>Go</button>
                    </div>
                )}
                <button className="logout-button" onClick={handleLogout}>
                    Logout
                </button>
            </div>
            <table id="chapters-table" className="display">
                <thead>
                    <tr>
                        <th>Chapter ID</th>
                        <th>Title</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {/* DataTable will populate this dynamically */}
                </tbody>
            </table>
        </div>
    );
};

export default Flipbook;
